exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-2801cb47]{border:none;border-radius:10px}.badge[data-v-2801cb47]{font-size:.75em}.list-group-item[data-v-2801cb47]{padding:.75rem 0;border:none;border-bottom:1px solid #f8f9fa}.list-group-item[data-v-2801cb47]:last-child{border-bottom:none}", ""]);

// exports
